var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"evaluate-list"},_vm._l((_vm.items),function(comment){return _c('commentItem',{key:comment.id,attrs:{"comment":comment,"imgLog":true}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }